import { Component, forwardRef } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../utils/pagination";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../actions/fillCombo_action";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import VendorDrawer from "../../../common_components/vendor_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import {
  getVendorWorkOrderList_action,
  deleteVendorWorkOrder_action,
} from "../../../actions/admin_module_action/vendor_action/vendorWorkOrder_action/vendorWorkOrder_action";
import { getVendorStaticList_action } from "../../../actions/vendor_module_action/vendor_order_action";
import { exhibitionId, toastError } from "../../../utils/constants";
import Select from "react-select";

const styles = {
  width: "100%",
};

class VendorStaticList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      vendorStaticList: [],
      currentPage: 1,
      ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
      exhibitionList: [],
      sortField: "",
      sortOrder: "",
      isVendor: JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 || JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 17,
      selectedHall: null,
      selectedService: null,
      companyFilter: "",
      showVideoModal: false,
    };
    this.updateItem = this.updateItem.bind(this);
    this.pollingTimer = null;
    // Exhibition of the last executed fetch, replayed by the background refresh
    this.lastExhibitionID = null;
  }

  componentDidMount() {
    this.getFillList(exhibitionId, "", "", "", "", "");
    this.getVendorStaticList();
    this.startPolling();
  }

  componentWillUnmount() {
    this.stopPolling();
  }

  // Refresh the list every 15s in the background (no page reload, no loader flicker)
  startPolling() {
    this.stopPolling();
    this.pollingTimer = setInterval(() => {
      if (this.state.showVideoModal || document.hidden) {
        return;
      }
      this.getVendorStaticList(true);
    }, 15000);
  }

  stopPolling() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer);
      this.pollingTimer = null;
    }
  }

  // isSilent = background poll: keep the loader hidden, keep the applied sort and don't
  // toast transient errors
  getVendorStaticList(isSilent = false) {
    const ExhibitionID =
      isSilent && this.lastExhibitionID !== null
        ? this.lastExhibitionID
        : this.state.ExhibitionID;
    this.lastExhibitionID = ExhibitionID;

    if (!isSilent) this.setState({ isLoading: true });
    try {
      this.props
        .getVendorStaticList_action(ExhibitionID)
        .then((data) => {
          if (data.error != 1) {
            if (!isSilent) console.log("Service Partner static list:", data.data);
            const list = data.data.vendorBasicDetail || [];
            const { sortField, sortOrder } = this.state;
            this.setState({
              vendorStaticList: sortField
                ? this.applySort(list, sortField, sortOrder)
                : list,
            });
          } else {
            if (!isSilent) toastError(data.msg);
          }
          if (!isSilent) this.setState({ isLoading: false });
        })
        .catch((err) => {
          console.log(err);
          if (!isSilent) this.setState({ isLoading: false });
        });
    } catch {
      if (!isSilent) {
        toastError("Something went wrong!");
        this.setState({ isLoading: false });
      }
    }
  }

  updateItem(item) {
    const { vendorStaticList } = this.state;
    this.setState({ currentPage: item });
    const recordsPerPage = 10;
    const indexOfLastRecord = item * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = vendorStaticList.slice(
      indexOfFirstRecord,
      indexOfLastRecord,
    );
    const nPages = Math.ceil(vendorStaticList.length / recordsPerPage);
  }

  // get fill List dropdown
  getFillList(
    actionID,
    exhibitionID,
    moduleID,
    keyValue,
    value,
    exhRegistrationID,
  ) {
    const { } = this.state;
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        actionID,
        exhibitionID,
        moduleID,
        keyValue,
        value,
        exhRegistrationID,
      )
      .then((data) => {
        if (data.error != 1) {
          // voucher list
          if (actionID === exhibitionId) {
            // console.log("voucher type data", data.data)
            this.setState({
              exhibitionList: data.data,
              isLoading: false,
            });
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  clearValue() {
    this.setState({
      ExhibitionID: "",
    });

    setTimeout(() => {
      this.getVendorStaticList();
    }, 100);
  }

  applySort(list, field, order) {
    return [...list].sort((a, b) => {
      const aVal = a[field];
      const bVal = b[field];

      // Handle numbers vs strings
      if (typeof aVal === "number" && typeof bVal === "number") {
        return order === "asc" ? aVal - bVal : bVal - aVal;
      }

      const aStr = (aVal || "").toString().toLowerCase();
      const bStr = (bVal || "").toString().toLowerCase();

      if (aStr < bStr) return order === "asc" ? -1 : 1;
      if (aStr > bStr) return order === "asc" ? 1 : -1;
      return 0;
    });
  }

  handleSort = (field) => {
    const { sortField, sortOrder, vendorStaticList } = this.state;
    const newSortOrder =
      sortField === field && sortOrder === "asc" ? "desc" : "asc";

    this.setState({
      vendorStaticList: this.applySort(vendorStaticList, field, newSortOrder),
      sortField: field,
      sortOrder: newSortOrder,
    });
  };

  getFilteredData() {
    const { vendorStaticList, selectedHall, selectedService, companyFilter } =
      this.state;
    return vendorStaticList.filter((vendor) => {
      const hallMatch = !selectedHall || vendor.HallName === selectedHall.value;
      const serviceMatch =
        !selectedService || vendor.ServiceName === selectedService.value;
      const companyMatch =
        !companyFilter ||
        (vendor.CompanyName || "")
          .toLowerCase()
          .includes(companyFilter.toLowerCase());
      return hallMatch && serviceMatch && companyMatch;
    });
  }

  getGroupedData() {
    const filteredData = this.getFilteredData();
    const grouped = {};

    filteredData.forEach((vendor) => {
      const key = `${vendor.HallName || "N/A"}_${vendor.ServiceName || "N/A"}`;
      if (!grouped[key]) {
        grouped[key] = {
          hallName: vendor.HallName || "N/A",
          serviceName: vendor.ServiceName || "N/A",
          vendors: [],
        };
      }

      const vendorKey = `${vendor.CompanyName}_${vendor.VendorPersonName}_${vendor.MobileNo}`;
      const existingVendor = grouped[key].vendors.find(
        (v) =>
          `${v.CompanyName}_${v.VendorPersonName}_${v.MobileNo}` === vendorKey,
      );

      if (existingVendor) {
        if (vendor.SubContractorCompanyName) {
          if (!existingVendor.subContractors) {
            existingVendor.subContractors = [];
          }
          existingVendor.subContractors.push({
            SubContractorCompanyName: vendor.SubContractorCompanyName,
            SubContractorPersonName: vendor.SubContractorPersonName,
            SubContractorMobileNo: vendor.SubContractorMobileNo,
            SubcontractorEmailID: vendor.SubcontractorEmailID,
          });
        }
        if (vendor.HallManagerCompanyName) {
          if (!existingVendor.hallManagers) {
            existingVendor.hallManagers = [];
          }
          existingVendor.hallManagers.push({
            HallManagerCompanyName: vendor.HallManagerCompanyName,
            HallManagerPersonName: vendor.HallManagerPersonName,
            HallManagerMobileNo: vendor.HallManagerMobileNo,
            HallManagerEmailID: vendor.HallManagerEmailID,
          });
        }
      } else {
        const vendorData = { ...vendor };
        if (vendor.SubContractorCompanyName) {
          vendorData.subContractors = [
            {
              SubContractorCompanyName: vendor.SubContractorCompanyName,
              SubContractorPersonName: vendor.SubContractorPersonName,
              SubContractorMobileNo: vendor.SubContractorMobileNo,
              SubcontractorEmailID: vendor.SubcontractorEmailID,
            },
          ];
        }
        if (vendor.HallManagerCompanyName) {
          vendorData.hallManagers = [
            {
              HallManagerCompanyName: vendor.HallManagerCompanyName,
              HallManagerPersonName: vendor.HallManagerPersonName,
              HallManagerMobileNo: vendor.HallManagerMobileNo,
              HallManagerEmailID: vendor.HallManagerEmailID,
            },
          ];
        }
        grouped[key].vendors.push(vendorData);
      }
    });

    return Object.values(grouped);
  }

  renderVendorStaticGrid() {
    const {
      sortField,
      sortOrder,
      selectedHall,
      selectedService,
      companyFilter,
      isVendor,
      vendorStaticList,
    } = this.state;
    const groupedData = this.getGroupedData();
    const roleID = JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID;

    const hallOptions = [
      ...new Set(vendorStaticList.map((vendor) => vendor.HallName)),
    ]
      .filter(Boolean)
      .map((hall) => ({ value: hall, label: hall }));

    const serviceOptions = [
      ...new Set(vendorStaticList.map((vendor) => vendor.ServiceName)),
    ]
      .filter(Boolean)
      .map((service) => ({ value: service, label: service }));

    return (
      <>
        <div
          className="mx-2 pt-2"
          style={{ zIndex: "0", position: "relative" }}
        >
          <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
            <Select
              value={selectedHall}
              onChange={(option) => this.setState({ selectedHall: option })}
              options={hallOptions}
              placeholder="Search by Hall / Location"
              isClearable
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{
                container: (base) => ({ ...base, minWidth: "180px" }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
            <Select
              value={selectedService}
              onChange={(option) => this.setState({ selectedService: option })}
              options={serviceOptions}
              placeholder="Search by Service"
              isClearable
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{
                container: (base) => ({ ...base, minWidth: "180px" }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
            <input
              type="text"
              className="form-control vendor-company-search-input"
              placeholder="Search by Company Name"
              value={companyFilter}
              onChange={(e) => this.setState({ companyFilter: e.target.value })}
            />
          </div>
        </div>
        <div className="pt-1 row m-0 p-2">
          <div className="table-responsive w-100 p-0 sticky-table-wrapper border-bottom service-list-grid">
            <table className="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0" style={{ borderBottom: "1px solid #ddd" }}>
              {/* <table
            className="table table-responsive border text-nowrap text-md-nowrap table-bordered p-0 mb-0 mt-1"
            style={{
              height: "calc(100vh - 330px)",
              overflow: "auto"
            }}
          > */}

              <thead className="table-light">
                <tr>
                  <th
                    className="text-left"
                    style={{ cursor: "pointer", width: "5%" }}
                    onClick={() => this.handleSort("HallName")}
                  >
                    Hall / Location Name
                    {sortField === "HallName" && (
                      <i
                        className={`fa fa-sort-${sortOrder === "asc" ? "up" : "down"
                          } ms-1`}
                      ></i>
                    )}
                  </th>
                  <th
                    className="text-left text-wrap"
                    style={{ cursor: "pointer", width: "22%", whiteSpace: "normal" }}
                    onClick={() => this.handleSort("ServiceName")}
                  >
                    Service
                    {sortField === "ServiceName" && (
                      <i
                        className={`fa fa-sort-${sortOrder === "asc" ? "up" : "down"
                          } ms-1`}
                      ></i>
                    )}
                  </th>

                  <th className="text-left" style={{ width: "auto" }}>
                    Service Partner Detail
                  </th>
                </tr>
              </thead>

              <tbody>
                {groupedData.length > 0 ? (
                  groupedData.map((group, index) => (
                    <tr key={index}>
                      <td
                        className="text-left"
                        style={{ width: "5%", verticalAlign: "top" }}
                      >
                        {group.hallName}
                      </td>

                      <td
                        className="text-left text-wrap"
                        style={{ width: "22%", verticalAlign: "top", whiteSpace: "normal" }}
                      >
                        {group.serviceName}
                      </td>

                      {/* LAST COLUMN AUTO EXPAND */}
                      <td style={{ width: "auto", padding: "8px" }}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "8px",
                          }}
                        >
                          {group.vendors.map((vendor, vendorIndex) => (
                            <div
                              key={vendorIndex}
                              className="card shadow-none border overflow-hidden p-1"
                              style={{
                                borderRadius: "8px",
                                minWidth: "250px",
                                flex: "1 1 calc(50% - 8px)",
                                marginBottom: "4px"
                              }}
                            >
                              <div className="d-flex h-100">
                                <div className="p-2 w-100 bg-white pt-0">
                                  <div className="d-flex justify-content-between align-items-start gap-2 mb-1 mt-0">
                                    <span className="fw-semibold" style={{ fontSize: '13px' }}>{vendor.CompanyName || "N/A"}</span>
                                    {!isVendor && (
                                      <span
                                        className="badge rounded-pill fw-semibold"
                                        style={{
                                          fontSize: '10px',
                                          backgroundColor: vendor.IsEmpanelVendor === "Yes" ? '#e6fffb' : '#f8fafc',
                                          color: vendor.IsEmpanelVendor === "Yes" ? '#3cbba7' : '#64748b',
                                          border: `1px solid ${vendor.IsEmpanelVendor === "Yes" ? '#3cbba7' : '#e2e8f0'}`
                                        }}
                                      >
                                        {vendor.IsEmpanelVendor === "Yes" ? "Empaneled" : "Non-Empaneled"}
                                      </span>
                                    )}
                                  </div>

                                  {!isVendor && vendor.IsEmpanelVendor === "No" && vendor.StallName && (
                                    <div className="d-flex align-items-center mb-1 " style={{ fontSize: '12px' }}>
                                      <i className="ri-store-2-line me-2 "></i>
                                      <span>{vendor.StallName}</span>
                                    </div>
                                  )}

                                  <div className="d-flex align-items-center mb-1 " style={{ fontSize: '12px' }}>
                                    <i className="ri-user-3-line me-2 "></i>
                                    <span className="fw-semibold">{vendor.VendorPersonName || "N/A"}</span>
                                  </div>

                                  <div className="d-flex align-items-center mb-1 " style={{ fontSize: '12px' }}>
                                    <i className="ri-phone-line me-2 "></i>
                                    <span>{vendor.MobileNo || "N/A"}</span>
                                  </div>

                                  <div className="d-flex align-items-center mb-2 " style={{ fontSize: '12px' }}>
                                    <i className="ri-mail-line me-2 "></i>
                                    <span style={{ wordBreak: 'break-all' }}>{vendor.PrimaryEmail || "N/A"}</span>
                                  </div>

                                  {vendor.subContractors && vendor.subContractors.length > 0 && (
                                    <div className="mt-3 pt-2 border-top">
                                      <div className="small fw-semibold text-dark mb-2 mt-0" style={{ fontSize: '11px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                                        Sub-Contractor{vendor.subContractors.length > 1 ? "s" : ""}
                                      </div>
                                      <div className="d-flex flex-wrap gap-3">
                                        {vendor.subContractors.map((sub, subIndex) => (
                                          <div key={subIndex}>
                                            <div className="fw-medium text-dark mb-1" style={{ fontSize: '12px' }}>
                                              <i className="ri-building-4-line me-1 "></i> {sub.SubContractorCompanyName}
                                            </div>
                                            {sub.SubContractorPersonName && (
                                              <div className=" mb-1" style={{ fontSize: '11px' }}>
                                                <i className="ri-user-line me-1"></i> {sub.SubContractorPersonName}
                                              </div>
                                            )}
                                            <div className="d-flex gap-3 " style={{ fontSize: '11px' }}>
                                              {sub.SubContractorMobileNo && <span><i className="ri-phone-line me-1"></i> {sub.SubContractorMobileNo}</span>}
                                              {sub.SubcontractorEmailID && <span className="text-truncate"><i className="ri-mail-line me-1"></i> {sub.SubcontractorEmailID}</span>}
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  )}

                                  {vendor.hallManagers && vendor.hallManagers.length > 0 && (
                                    <div className="mt-2 pt-2 border-top">
                                      <div className="small fw-semibold text-dark mb-2 mt-0" style={{ fontSize: '11px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                                        Team Member{vendor.hallManagers.length > 1 ? "s" : ""}
                                      </div>
                                      <div className="d-flex flex-wrap gap-3">
                                        {vendor.hallManagers.map((hall, hallIndex) => (
                                          <div key={hallIndex}>
                                            {hall.HallManagerPersonName && (
                                              <div className="fw-semibold text-dark mb-1" style={{ fontSize: '12px' }}>
                                                <i className="ri-user-line me-1 "></i> {hall.HallManagerPersonName}
                                              </div>
                                            )}
                                            <div className="d-flex gap-3 " style={{ fontSize: '11px' }}>
                                              {hall.HallManagerMobileNo && <span><i className="ri-phone-line me-1"></i> {hall.HallManagerMobileNo}</span>}
                                              {hall.HallManagerEmailID && <span className="text-truncate"><i className="ri-mail-line me-1"></i> {hall.HallManagerEmailID}</span>}
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center  py-4">
                      No vendor data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* </div> */}
      </>
    );
  }

  render() {
    const {
      isLoading,
      vendorStaticList,
      isVendor,
      currentPage,
      showVideoModal,
    } = this.state;

    console.log("vendorStaticList", vendorStaticList);
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {isVendor && showVideoModal && (
          <div
            className="modal show d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            onClick={() => this.setState({ showVideoModal: false })}
          >
            <div
              className="modal-dialog modal-lg modal-dialog-centered"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Service Partner List</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => this.setState({ showVideoModal: false })}
                  ></button>
                </div>
                <div className="modal-body">
                  <video controls autoPlay style={{ width: "100%" }}>
                    <source
                      src="/assets/VendorServicePartnerList.mp4"
                      type="video/mp4"
                    />
                  </video>
                </div>
              </div>
            </div>
          </div>
        )}
        {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
          <ExhibitorHeader />
        ) : (
          <HeaderWithLogo />
        )}
        <div
          className={`main-content ${JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? "exb-top-space-2" : "admin-top-space"}`}
          style={
            JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1
              ? {
                marginLeft: "200px",
                paddingLeft: "15px",
                paddingRight: "15px",
              }
              : {}
          }
        >
          {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
            <ExhibitorDrawer />
          ) : (JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 || JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 17) ? (
            <VendorDrawer />
          ) : (
            <AdminDrawer />
          )}
          {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
            <ExhibitorTopMenu />
          ) : null}
          {isVendor && (
            <div className="d-flex justify-content-end px-2 pt-3 text-aqua d-none">
              {/* <span
                onClick={() => this.setState({ showVideoModal: true })}
                style={{
                  cursor: "pointer",
                  color: "#3dbca7",
                  fontSize: "16px",
                  marginLeft: "auto",
                }}
              >
                <i className="bi bi-play-circle-fill me-2"></i>User Manual
              </span> */}
            </div>
          )}
          {this.renderVendorStaticGrid()}
        </div>
        <div
          className={
            JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1
              ? "with-dr-container exb-side-space"
              : "with-dr-container com-height"
          }
          style={{ margin: isVendor ? 0 : "" }}
        ></div>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    fill_action,
    getVendorStaticList_action,
  })(VendorStaticList),
);
